import React, {Fragment} from 'react'
import { SliderCarousel } from '../components/SliderCarousel'
import { LineasProduct } from '../components/LineasProduct'
import { SliderCualidades } from '../components/SliderCualidades'
import { SliderTestimonios } from '../components/SliderTestimonios'
import { Carousel, Col, Row, Space } from 'antd';


export const Home = () => {
    return (
        <Space direction="vertical" size={100} style={{ display: 'flex' }}>
            <SliderCarousel />
            <LineasProduct />
            <SliderTestimonios />
            <SliderCualidades />
        </Space>
    )
  }